import { createFileRoute } from "@tanstack/react-router";

import { KeysPanel } from "../../../workspaces/settings/KeysPanel";

export const Route = createFileRoute("/_console/settings/keys")({
  component: KeysPanel,
});
